import Vue from 'vue'

// https://cn.vuejs.org/v2/guide/render-function.html#函数式组件
Vue.component('el-button-export', {
    functional: true,
    // Props 是可选的
    props: {
        url: Function,
        type: {
            type: String,
            default: 'text',
        },
        size: String
    },
    // 为了弥补缺少的实例
    // 提供第二个参数作为上下文
    render: function (h, ctx) {
        const isText = ctx.props.type == 'text';
        return h('el-button', {
            props: {
                type: ctx.props.type,
                size: ctx.props.size
            },
            on: {
                click: () => { 
                    const url = ctx.props.url();
                    if(url) window.open(url);
                }
            },
            style: {
                margin: 0,
                color: isText? '#606266' : null,
                fontSize: isText? '14px' : null
            }
        }, ctx.children)
    }
  })